import {useAuth} from "../../authprovider";
import React, {useEffect, useState} from "react";
import {Alert, Button, Card, Form, InputGroup, Modal, Table} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPenToSquare, faSpinner, faTrashCan} from "@fortawesome/free-solid-svg-icons";


export default function UsersCard(props){
    const auth = useAuth();
    const [building] = useState(props['data-building'])
    const [mobileUsers, setMobileUsers] = useState(building.users)
    const [users, setUsers] = useState(undefined)
    const [managerModal, setManagerModal] = useState({
        show:false,
        manager: undefined
    })

    useEffect(()=>{
        if(users !== undefined || !building.id)
            return;

        auth.buildings.getUsers(building.id, response=>{
            const {success, error, content} = response;

            if(success === true){
                setUsers(content)
            } else {
                alert(error)
            }
        })
    })

    const editUser = (id)=>{
        const manager = users.find((man)=>man.id === id);

        if(!manager)
            return;

        setManagerModal({
            show:true,
            manager: manager
        })
    }

    const deleteUser = (id)=>{
        const user = users.find((val)=>val.id === id);

        if(!user)
            return;

        if(window.confirm("Potwierdź usunięcie użytkownika: "+user.login)){

            auth.buildings.deleteManager(id, response=>{
                const {success, error} = response;

                if(success === true){
                    setUsers(users.filter((user)=>user.id !== id))
                } else {
                    alert(error);
                }
            });
        }
    }

    const showCreateManagerModal = ()=>{
        setManagerModal({
            show:true,
            manager: undefined
        })
    }

    const onHideCreateManagerModal = (result, edit)=>{

        if(result){
            download(undefined, {login:result.login, password:result.password} );
            if(edit)
                setUsers(users.map(user=>{
                    if(user.id === result.id)
                        return result

                    return user;
                }));
            else
                setUsers([...users, result])
        }

        setManagerModal({
            show:false,
        })
    }

    const handleAddUsers = ()=>{
        const res = window.prompt("Wprowadź liczbę użytkowników do dodania", 0);
        const num = Number(res)

        if(!Number.isInteger(num))
            return handleAddUsers()

        if(num === 0 )
            return;


        const data = {
            building_id:building.id,
            users_number: num
        }

        auth.buildings.addMobileUsers(data, response=>{
            const {success, error, content} = response;

            if(success === true){
                setMobileUsers(mobileUsers+content.length)
                download(building, content.map((val)=>val.code));
            } else {
                alert(error)
            }
        })

    }

    return (
        <div className={"col-8"}>
            <Card className={"m-2"} key={"data"}>
                <Card.Header as={"h5"}>Użytkownicy i zarząd</Card.Header>
                <Card.Body>
                    <div className={"border border-1 m-2 p-4"}>
                        <h6 className={"d-flex justify-content-between"}><span>Użytkownicy mobilni: <b className={"bg-warning text-black p-2"}>{mobileUsers}</b></span> <Button name={"Dodaj"} variant="outline-secondary" id="btnAddUsers" onClick={handleAddUsers}>
                            Dodaj
                        </Button></h6>
                        <Form.Text id="usersHelpBox" muted>
                            Użytkownicy mobilni przypisany do tego obiektu. Aby wygenerować nowe hasła, kliknij dodaj i wprowadź liczbę użytkowników. System poprosi o zapis pliku, w którym będą znajdowały się wygenerowane hasła.
                        </Form.Text>
                    </div>

                    <div className={"border border-1 m-2 p-4"}>
                        <h6 className={"d-flex justify-content-between"}><span>Obsługa obiektu: <b className={"bg-warning text-black p-2"}>{users?.length}</b></span>
                            <Button name={"Dodaj zarządcę"} variant={"outline-secondary"} onClick={showCreateManagerModal} >Dodaj</Button>
                        </h6>
                        <Form.Text id="usersHelpBox" muted>
                          Obsługa obiektu to zarządcy oraz pracownicy ochrony mający dostęp do systemu z poziomu strony www.<br/>Aby wygenerować nowe konto pracownika, kliknij dodaj i wprowadź dane. System poprosi o zapis pliku, w którym będą znajdowały się dane pracownika.
                        </Form.Text>
                        <Table striped bordered hover>
                            <thead>
                            <tr className={"text-center text-capitalize"}>
                                <th>#</th>
                                <th>Login</th>
                                <th>Email</th>
                                <th>Rola</th>
                                <th>Akcje</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                users && users.map((user, index)=>{
                                    return(
                                        <tr className={"text-center"} key={user.id}>
                                            <td>{index+1}</td>
                                            <td>{user.login}</td>
                                            <td>{user.email}</td>
                                            <td>{user.role}</td>
                                            <td >
                                                <Button name={ "Edycja"} variant={"outline-primary"} title={"Edycja"} onClick={()=>editUser(user.id)} ><FontAwesomeIcon icon={faPenToSquare} /></Button>
                                                <Button name={"Usuń"} className={"ms-2"} title={"Usuń"} variant={"outline-primary"} onClick={()=>deleteUser(user.id)} ><FontAwesomeIcon icon={faTrashCan} /></Button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }


                            </tbody>
                        </Table>
                    </div>
                  </Card.Body>
            </Card>
            <AddManagerModal show={managerModal.show} data-manager={managerModal.manager} data-building={building.id} onHide={onHideCreateManagerModal} />

        </div>
    )
}


function AddManagerModal(props){
    const auth = useAuth();
    const manager = props['data-manager'];
    const buildingId = props['data-building'];
    const [validated, setValidated] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState({
        show:false,
        content: "",
    })



    const hideAlert = ()=>{ setAlert({show:false, content: ""})}

    const handleSubmit = (event)=>{

        event.preventDefault();
        event.stopPropagation();

        if(disabled)
            return;

        const form = event.currentTarget;

        if (form.checkValidity() === true) {
            setDisabled(true);
            let elements = form.elements
            let data = {
                login:elements.login.value,
                password:elements.password.value,
                role:elements.role.value,
                buildingId:buildingId,
            }
            let edition = false;

            if(manager){
                data.id = manager.id;
                edition = true;
            }


            auth.buildings.addEditManager(data, edition, response=>{
                const {success, error, content} = response;

                if(success === true){
                    props.onHide(content, !!manager );
                } else {
                    setAlert({show:true, content: error})
                }

                setDisabled(false);
            })

        }

        setValidated(true);
    }


    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    {
                        manager ?
                            "Edycja pracownika"
                            :
                            "Nowy pracownik"
                    }
                </Modal.Title>
            </Modal.Header>
            <Form disabled noValidate validated={validated} action={"post"} onSubmit={handleSubmit} >
                <Modal.Body>
                    <Alert show={alert.show} variant={"warning"} onClose={hideAlert} dismissible>
                        <p>
                            {alert.content}
                        </p>
                    </Alert>
                    <Form.Group className="mb-3" controlId="userLogin">
                        <Form.Label>Login pracownika</Form.Label>
                        <Form.Control required type="text" name={"login"} placeholder="login" defaultValue={manager ? manager.login : ""} />
                        <Form.Text className="text-muted" >
                            Login zarządcy/obsługi obiektu
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="userPassword">
                        <Form.Label>Hasło pracownika</Form.Label>
                        <Form.Control type="text" name={"password"} placeholder={manager ? "wprowadź hasło aby je zmienić" : "hasło"}  />
                        <Form.Text className="text-muted" >
                            Hasło zarządcy/obsługi obiektu (pozostaw puste - system automatycznie wygeneruje hasło)
                        </Form.Text>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="userRole">
                        <Form.Label>Rola pracownika</Form.Label>
                        <Form.Select name={"role"} defaultValue={ manager ? manager.role : "MANAGER"} aria-label="Select worker role">
                            <option value="MANAGER">Zarządca</option>
                            <option value="STEWARD">Ochrona</option>
                        </Form.Select>
                    </Form.Group>
                    {/*<Form.Group className="mb-3" controlId="objectAddress">*/}
                    {/*    <Form.Label>Email</Form.Label>*/}
                    {/*    <Form.Control type="email" name={"email"} placeholder="adres email" />*/}
                    {/*    <Form.Text className="text-muted" >*/}
                    {/*        Email pracownika (pole nie jest wymagane)*/}
                    {/*    </Form.Text>*/}
                    {/*</Form.Group>*/}
                </Modal.Body>
                <Modal.Footer>
                    <Button  disabled={disabled} type={"submit"} name={"Zapisz"}>
                        {disabled ? <FontAwesomeIcon icon={faSpinner}  spin/> : "Dodaj" }
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

/**
 * Function providing/generates downloading file from json in browser
 * @param building
 * @param values
 */
const download = (building, values)=>{
    let filename = 'User_metada';

    if(building  !== undefined)
        filename = building.code+"_users";


    const blob = new Blob([JSON.stringify(values)], { type: 'text/plain' })
    // Create an object URL for the blob object
    const url = URL.createObjectURL(blob);

    // Create a new anchor element
    const a = window.document.createElement('a');

    a.href = url;
    a.download = filename;
    // Click handler that releases the object URL after the element has been clicked
    // This is required for one-off downloads of the blob content
    const clickHandler = () => {
        setTimeout(() => {
            URL.revokeObjectURL(url);
        }, 150);
    };

    // Add the click event listener on the anchor element
    // Comment out this line if you don't want a one-off download of the blob content
    a.addEventListener('click', clickHandler, false);

    // Programmatically trigger a click on the anchor element
    // Useful if you want the download to happen automatically
    // Without attaching the anchor element to the DOM
    // Comment out this line if you don't want an automatic download of the blob content
    a.click();
}